import { Controller, useFormContext, type FieldPath } from "react-hook-form";

import { Select } from "ui/select";

import type { EmailConfigurationFormValues } from "containers/admin/clients/client/theme-configuration-page/configuration/email-configuration/email-configuration.types";

type FormSelectOption = { label: string; value: string };

type FormSelectProps = {
  name: FieldPath<EmailConfigurationFormValues>;
  label: string;
  options: ReadonlyArray<FormSelectOption>;
  disabled: boolean;
  /** Runs after the field takes the new value, for fields that depend on this one. */
  onValueChange?: (value: string) => void;
};

/** A string field picked from a fixed list; a saved value outside the list shows as empty. */
export const FormSelect = ({ name, label, options, disabled, onValueChange }: FormSelectProps) => {
  const { control } = useFormContext<EmailConfigurationFormValues>();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const handleChange = (option: FormSelectOption | null) => {
          if (option) {
            field.onChange(option.value);
            onValueChange?.(option.value);
          }
        };

        return (
          <Select<FormSelectOption>
            selectName={`${name}-select`}
            ariaLabel={label}
            label={label}
            options={[...options]}
            value={options.find(({ value }) => value === field.value) ?? null}
            onChange={handleChange}
            onBlur={field.onBlur}
            disabled={disabled}
            disableClearable
            isSearchable={false}
          />
        );
      }}
    />
  );
};
